import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50" data-testid="protected-loading">
        <div className="text-slate-500">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const fallback =
      user.role === "client" ? "/portal" :
      user.role === "tradeline_admin" ? "/tradeline-admin" :
      "/admin";
    return <Navigate to={fallback} replace />;
  }
  return children;
}
